import { axios } from "../../cores/axiosWrapper";

export const getCustomMenuSetsAPI = async (apiEndpoint, projectId, params) => {
    return axios.get(`${apiEndpoint}/custom-menu-sets`, {
        params,
        headers: {
            projectId,
        },
    });
};

export const getCustomMenuSetDetailAPI = async (apiEndpoint, projectId, setId, params) => {
    return axios.get(`${apiEndpoint}/custom-menu-sets/${setId}`, {
        params,
        headers: {
            projectId,
        },
    });
};

export const getCustomMenusAPI = async (apiEndpoint, projectId, setId, params) => {
    return axios.get(`${apiEndpoint}/custom-menu-sets/${setId}/menus`, {
        params,
        headers: {
            projectId,
        },
    });
};

export const getCustomMenuDetailAPI = async (apiEndpoint, projectId, setId, menuId, params) => {
    return axios.get(`${apiEndpoint}/custom-menu-sets/${setId}/menus/${menuId}`, {
        params,
        headers: {
            projectId,
        },
    });
};

export const createCustomMenuSetAPI = async (apiEndpoint, projectId, data) => {
    return axios.post(`${apiEndpoint}/custom-menu-sets`, data, {
        headers: {
            projectId,
        },
    });
};

export const addCustomMenuAPI = async (apiEndpoint, projectId, setId, data) => {
    return axios.post(`${apiEndpoint}/custom-menu-sets/${setId}/menus`, data, {
        headers: {
            projectId,
        },
    });
};

export const updateCustomMenuAPI = async (apiEndpoint, projectId, setId, menuId, data) => {
    return axios.patch(`${apiEndpoint}/custom-menu-sets/${setId}/menus/${menuId}`, data, {
        headers: {
            projectId,
        },
    });
};

export const deleteCustomMenuAPI = async (apiEndpoint, projectId, setId, menuId) => {
    return axios.delete(`${apiEndpoint}/custom-menu-sets/${setId}/menus/${menuId}`, {
        headers: {
            projectId,
        },
    });
};

export const updateCustomMenuActionsAPI = async (apiEndpoint, projectId, setId, data) => {
    return axios.post(`${apiEndpoint}/custom-menu-sets/${setId}/actions`, data, {
        headers: {
            projectId,
        },
    });
};
